import { useEffect, useState } from 'react'
import { apis } from '../api/apiUrl'

const useFetch = url => {
  const [data, setData] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetch(`${apis.umbraco_delivery_api}/${url}`)
      const data = await response.json()
      setData(data)
    }
    if (url) {
      fetchData()
    }
  }, [url])

  return data
}

export default useFetch
